import React from "react";
import { PagesContainer } from "../../containers";
import { PartnershipInquiryScreen } from "../../screens";

const PartnershipInquiry = (props) => {
  return (
    <PagesContainer {...props}>
      <PartnershipInquiryScreen {...props} />
    </PagesContainer>
  );
};

PartnershipInquiry.defaultProps = {};

export default PartnershipInquiry;
